import { useMutation } from "@tanstack/react-query";
import { useSessionJWT, useSessionCtx } from "utils";
import { intentDeposit } from "./";

export default function useIntentDeposit() {
  const { sessionJWT } = useSessionJWT();
  const { sessionId } = useSessionCtx();
  const ctx = {
    ...sessionJWT,
    sessionId,
  };

  return useMutation({
    mutationFn: ({
      accountId,
      requestAmount,
      requestAmountFee,
      depositPaymentMethodId,
      depositType,
      destinationWalletId,
      depositProvider,
      requestCurrency,
    }) =>
      intentDeposit(ctx, {
        accountId,
        requestAmount,
        requestAmountFee,
        depositPaymentMethodId,
        depositType,
        destinationWalletId,
        depositProvider,
        requestCurrency,
      })
  });
}
